import { useEffect, useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { AccountModel, NgoaiTe, NgoaiTeInput, TKData } from '@/types/schemas';
import { FormSchema, FormValues, initialFormValues } from '../../schemas';
import { BasicInfoTab } from './BasicInfoTab';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
  open: boolean;
  initialData?: NgoaiTe;
  onSubmit?: (data: NgoaiTeInput) => void;
  onClose: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAdd,
  onEdit,
  onDelete,
  onCopy
}: FormDialogProps) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);
  const [taiKhoanNo, setTaiKhoanNo] = useState<AccountModel | TKData | null>(initialData?.tk_pscl_no_data || null);
  const [taiKhoanCo, setTaiKhoanCo] = useState<AccountModel | TKData | null>(initialData?.tk_pscl_co_data || null);

  useEffect(() => {
    if (!open) {
      setIsFormDirty(false);
    }
  }, [open]);

  const handleSubmit = (data: FormValues) => {
    onSubmit?.({
      ...data,
      tk_pscl_no: taiKhoanNo?.uuid,
      tk_pscl_co: taiKhoanCo?.uuid,
      cach_doc: data.ten_nt,
      stt: data.stt || 0,
      ra_ndec: data.ra_ndec || 0
    });
    setIsFormDirty(false);
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục ngoại tệ'}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          onClose={onClose}
          initialData={(initialData || initialFormValues) as FormValues}
          className='w-[800px] overflow-y-auto'
          headerFields={
            <div onChange={() => setIsFormDirty(true)}>
              <BasicInfoTab
                formMode={formMode}
                taiKhoanNo={taiKhoanNo}
                taiKhoanCo={taiKhoanCo}
                setTaiKhoanNo={setTaiKhoanNo}
                setTaiKhoanCo={setTaiKhoanCo}
              />
            </div>
          }
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onClose={onClose}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
